import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full mt-20 rounded-t-[2rem] bg-surface-container-low border-t border-outline-variant/10 dark:border-transparent">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 px-12 py-16 max-w-7xl mx-auto">
        <div>
          <div className="font-['Space_Grotesk'] font-bold text-lg text-primary mb-6">JSLipi</div>
          <p className="text-on-surface-variant text-sm leading-relaxed mb-6">
            Engineering editorial for the modern architect. Curated tutorials, reference guides, and industry insights.
          </p>
          <div className="flex gap-4">
            <a href="/rss.xml" aria-label="RSS feed" className="material-symbols-outlined text-primary/60 hover:text-primary transition-colors">rss_feed</a>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-8">
          <div>
            <h5 className="text-primary font-bold mb-4">Network</h5>
            <ul className="space-y-3 text-sm text-on-surface-variant">
              <li><Link to="/about" className="hover:underline">About Author</Link></li>
              <li><Link to="/early-access" className="hover:underline">Early access</Link></li>
              <li><a href="/rss.xml" className="hover:underline">RSS Feed</a></li>
            </ul>
          </div>
          <div>
            <h5 className="text-primary font-bold mb-4">Support</h5>
            <ul className="space-y-3 text-sm text-on-surface-variant">
              <li><Link to="/privacy" className="hover:underline">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:underline">Terms of Use</Link></li>
              <li><Link to="/contact" className="hover:underline">Contact</Link></li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col justify-between items-start md:items-end">
          <div className="text-right">
            <div className="text-primary font-semibold mb-2">Build with precision.</div>
            <div className="text-on-surface-variant text-xs">Updated Mar 2026</div>
          </div>
          <p className="text-on-surface-variant text-sm antialiased mt-12 md:mt-0">
            © 2026 JSLipi. Crafted for the Digital Architect.
          </p>
        </div>
      </div>
    </footer>
  );
}